/**
 * Shared layout for every legal policy page so all four pages stay
 * visually consistent with the rest of Sri Durga Foods (same container
 * width, typography scale, brand colours).  Title + last-updated header
 * is rendered once here; the page passes children as the body.
 */
import { CONTACT, useContactNumber, useContactEmail } from "../../lib/contact";
import SEOHead from "../../components/SEOHead";

export default function PolicyLayout({ title, lastUpdated = "February 2026", testid, seoTitle, seoDescription, canonical, children }) {
  // iter53 — live admin-editable call number.
  const contact = useContactNumber();
  // iter71 — live admin-editable customer email.
  const email = useContactEmail();
  return (
    <div className="container-x py-12 lg:py-20" data-testid={testid}>
      <SEOHead
        title={seoTitle || `${title} | Sri Durga Foods`}
        description={seoDescription || `${title} for Sri Durga Foods — authentic Andhra pickles, spices, masalas, and wood-pressed oils. Last updated ${lastUpdated}.`}
        canonical={canonical}
      />
      <div className="max-w-3xl mx-auto">
        <span className="overline mb-3 block">Sri Durga Foods</span>
        <h1 className="font-serif text-4xl sm:text-5xl text-brand-dark mb-3">{title}</h1>
        <p className="text-xs text-brand-muted mb-10">Last updated: {lastUpdated}</p>

        <div className="prose-policy space-y-7 text-[15px] leading-relaxed text-brand-dark/85">
          {children}

          <section className="border-t border-brand-line pt-7 mt-10">
            <h2 className="font-serif text-2xl text-brand-dark mb-3">Contact us</h2>
            <p>
              For any questions about this policy, reach our customer care team:
            </p>
            <ul className="mt-3 space-y-1.5 text-sm">
              <li><strong>Address:</strong> {CONTACT.ADDRESS}</li>
              <li><strong>Phone:</strong> <a href={contact.tel} className="text-brand-chili hover:underline">{contact.display}</a></li>
              <li><strong>WhatsApp:</strong> <a href={`https://wa.me/${CONTACT.WHATSAPP}`} target="_blank" rel="noreferrer" className="text-brand-chili hover:underline">{CONTACT.WHATSAPP_DISPLAY}</a></li>
              <li><strong>Email:</strong> <a href={email.mailto()} className="text-brand-chili hover:underline">{email.address}</a></li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
}

// Small helpers re-used by every policy page below.
export function H2({ children }) {
  return <h2 className="font-serif text-2xl sm:text-3xl text-brand-dark mt-8 mb-3">{children}</h2>;
}
export function H3({ children }) {
  return <h3 className="font-medium text-lg text-brand-dark mt-5 mb-2">{children}</h3>;
}
export function P({ children }) {
  return <p>{children}</p>;
}
export function UL({ children }) {
  return <ul className="list-disc pl-6 space-y-1.5">{children}</ul>;
}
